module.exports = __webpack_public_path__ + "141d4a85/img/revit-icon.5ff0d581.svg";